import { UserService } from '@business/services';
import { UserAPI } from '@business/api/user';
import { BaseBloc } from '@core/utils/bloc';
import { Session } from '@modules/auth/session';
import { R } from '@core/utils/r';
import { useHistory } from '@core/router';
import { tap } from 'rxjs/operators';
import { open2FAInfoModal } from '@modules/account/TwoFactorInfoModal';

export class AuthBloc extends BaseBloc {
  addScript(accountId: string, accountUrl: string, productId: string) {
    const rcsOld = document.getElementById('vv-script');
    if (R.isEmpty(accountId) || R.isEmpty(accountUrl) || R.isEmpty(productId)) {
      return;
    }
    if (rcsOld) {
      return;
    }

    const rcs = document.createElement('script');
    rcs.setAttribute('id', 'vv-script');
    rcs.setAttribute('data-url', accountUrl);
    rcs.setAttribute('data-account-id', accountId);
    rcs.setAttribute('data-app-id', productId);
    rcs.setAttribute('target-element-class', 'navbar-parent');
    rcs.src = `//www.cdnstyles.com/static/product_navbar/v1/product_navbar.js`;
    const rcs0 = document.getElementsByTagName('script')[0];
    rcs0.parentNode!.insertBefore(rcs, rcs0);
  }

  removeScript() {
    const rcs = document.getElementById('vv-script');

    if (rcs) {
      rcs.parentNode!.removeChild(rcs);
    }
  }
  onReset() {}

  onInit() {
    const user = Session.user;
    if (user) {
      this.addScript(user.externalAccountId, user.externalAccountUrl, user.externalProductId);
      if (user.email.includes('@grandcentr.al') && !R.isEmpty(user.externalAccountId) && document.location.pathname !== '/set-email') {
        document.location.href = '/set-email';
      }

      if (UserService.isStaff(user) && user.twoFactor === false) {
        UserAPI.findMeta<boolean>('2fa-notfication')
          .pipe(
            tap(res => {
              if (res.value !== true) {
                open2FAInfoModal();
              }
            }),
          )
          .subscribe();
      }
    }
  }
}
